
import { useEffect, useState } from 'react'

export interface Pricing {
  price: string
  currency: 'ARS' | 'USD'
  anchor: string
  loading: boolean
}

const AR_PRICING: Omit<Pricing, 'loading'> = {
  price: '24.990',
  currency: 'ARS',
  anchor: '44.990',
}

const INTL_PRICING: Omit<Pricing, 'loading'> = {
  price: '16.99',
  currency: 'USD',
  anchor: '29.99',
}

export function usePricing(): Pricing {
  const [country, setCountry] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    const controller = new AbortController()
    const timeout = window.setTimeout(() => controller.abort(), 4000)

    async function detect() {
      try {
        const res = await fetch('https://ipapi.co/json/', {
          signal: controller.signal,
        })
        if (!res.ok) throw new Error('geo lookup failed')
        const data = await res.json()
        if (!cancelled) setCountry(data.country_code ?? null)
      } catch {
        // Fallback a USD si falla
        if (!cancelled) setCountry(null)
      } finally {
        window.clearTimeout(timeout)
        if (!cancelled) setLoading(false)
      }
    }

    detect()

    return () => {
      cancelled = true
      controller.abort()
      window.clearTimeout(timeout)
    }
  }, [])

  const isArgentina = country?.toUpperCase() === 'AR'

  return {
    ...(isArgentina ? AR_PRICING : INTL_PRICING),
    loading,
  }
}
